import {AxiosError} from 'axios';
import {useQueryClient} from 'react-query';
import {UpdateCandidateProfileDetailsRequest} from '../../api/user/model';
import {PUT_UPDATE_CANDIDATE_PROFILE_DETAILS_URL} from '../../constants/apiUrls';
import {GET_CANDIDATE_PROFILE_DETAILS_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutCandidateProfileDetails = ({onSuccess, onError}: Input = {}) => {
  const queryClient = useQueryClient();

  const putCandidateProfileDetails = async (reqBody: UpdateCandidateProfileDetailsRequest) => {
    await axiosClient.put(PUT_UPDATE_CANDIDATE_PROFILE_DETAILS_URL, reqBody);
  };

  return useCustomMutation(putCandidateProfileDetails, {
    onSuccess: () => {
      queryClient.invalidateQueries(GET_CANDIDATE_PROFILE_DETAILS_QUERY_KEY);
      onSuccess?.();
    },
    onError,
  });
};
